export type PendingFirstOffer = { teamId: number; pathname: string };

const KEY = "autopto-pending-first-offer";

export const readPendingFirstOffer = (): PendingFirstOffer | null => {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(KEY) ?? "null");
    if (
      value &&
      typeof value === "object" &&
      "teamId" in value &&
      typeof value.teamId === "number" &&
      "pathname" in value &&
      typeof value.pathname === "string"
    )
      return { teamId: value.teamId, pathname: value.pathname };
  } catch {
    // Storage is optional.
  }

  return null;
};

export const writePendingFirstOffer = (value: PendingFirstOffer | null) => {
  try {
    if (value) sessionStorage.setItem(KEY, JSON.stringify(value));
    else sessionStorage.removeItem(KEY);
  } catch {
    // The mounted provider still remembers the wait.
  }
};
